import { render, staticRenderFns } from "./Dash1Skeleton.vue?vue&type=template&id=71deca43"
import script from "./Dash1Skeleton.vue?vue&type=script&lang=js"
export * from "./Dash1Skeleton.vue?vue&type=script&lang=js"
import style0 from "./Dash1Skeleton.vue?vue&type=style&index=0&id=71deca43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports